module.exports = "<h2>{{$state.current.data.stepCaption}}</h2> <div ui-view></div> <h2>Transactions</h2> <crud-clerk-transaction-row-curate></crud-clerk-transaction-row-curate> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/crud/clerk-ledger/steps/transactions.transactions.html
// module id = 2518
// module chunks = 86